import HeaderText from "src/Candidate/molecules/HeaderText";
import { LegalHeaderProps } from "./LegalHeader.types";
import styles from "./LegalHeader.module.css";

export default function LegalHeader({
  title = "Cookies Policy",
  description = "Please read these cookies policy carefully before using our website and services.",
}: LegalHeaderProps): JSX.Element {
  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <HeaderText title={title} description={description} />
      </div>
    </div>
  );
}
